import requests from "@/api/axios";


export async function sendEmail(data) {
    return await requests.post("web/photo/email", data);
}
